<h2 mat-dialog-title>
    Membership Codes
</h2>
<mat-dialog-content>
    <div style="width: 100%">
        <mat-table style="width: 100%;" [dataSource]="membershipDetails">
            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <mat-header-cell style="flex: 1" *matHeaderCellDef>Start Date</mat-header-cell>
                <mat-cell style="flex: 1" *matCellDef="let e">{{e.StartDate | date: 'MM/dd/yy'}}</mat-cell>
            </ng-container>
            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
                <mat-header-cell style="flex: 1" *matHeaderCellDef>End Date</mat-header-cell>
                <mat-cell style="flex: 1" *matCellDef="let e">{{e.EndDate | date: 'MM/dd/yy'}}</mat-cell>
            </ng-container>
            <!-- Code Column -->
            <ng-container matColumnDef="code">
                <mat-header-cell style="flex: 3" *matHeaderCellDef>Code</mat-header-cell>
                <mat-cell style="flex: 3" *matCellDef="let e">{{e.Code}}</mat-cell>
            </ng-container>
            <!-- Updated By Column -->
            <ng-container matColumnDef="updatedBy">
                <mat-header-cell style="flex: 1" *matHeaderCellDef>Updated By</mat-header-cell>
                <mat-cell style="flex: 1" *matCellDef="let e">{{e.UpdatedBy}}</mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row style="min-height: 30px;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <!-- Membership Code Detail Message -->
    <div style="display: flex;justify-content: center;padding-top: 20px;color: rgba(0,0,0,.8);">
        The default value of <span style="font-style: italic;margin-right: 4px;margin-left: 4px;">{{membershipCode}}</span> applies in all dates outside the above-listed ranges.
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="flex-footer-left"></div>
    <div class="flex-footer-right">
        <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()" translate></tyl-button>
    </div>
</mat-dialog-actions>
